import type { HelpdeskPublicMessages } from "./helpdeskPublicCatalog";
import type { InstallableLocale } from "./i18n/preparedLocales";

/** Existing native copy remains the fallback for every other installed locale. */
export function contactFirstCopy(locale: InstallableLocale, t: HelpdeskPublicMessages) {
  if (locale === "en") return {
    title: "Digital safety support. Start here.",
    body: "For account compromise, surveillance, phishing or device risks. Choose a channel that is safe for you.",
    recommended: "Recommended when safe for you", firstTitle: "A short first message is enough.",
    prompts: [
      { title: "What happened?", body: "Briefly describe your immediate concern, such as a suspicious login or a phishing message." },
      { title: "What is affected?", body: "Tell us which account or device is involved, such as an email account or a phone." },
      { title: "Is this device safe?", body: "Let us know if the device may be monitored, lost or confiscated." },
    ],
    warning: "Do not send passwords, verification codes or suspicious files.", pgpTitle: "Sending sensitive email?",
    pgpBody: "Verify the public-key fingerprint through a second trusted channel.", fingerprintAction: "View fingerprint",
    next: ["We assess the risk", "Agree on a safer next step", "Collect information only with your consent"],
  };
  if (locale === "fa") return {
    title: "پشتیبانی امنیت دیجیتال؛ از اینجا شروع کنید.",
    body: "برای نفوذ به حساب، نظارت، فیشینگ یا خطرهای دستگاه، از راهی که برای شما امن است تماس بگیرید.",
    recommended: "پیشنهاد ما، اگر برای شما امن است", firstTitle: "یک پیام کوتاه برای شروع کافی است.",
    prompts: [
      { title: "چه اتفاقی افتاده؟", body: "نگرانی فوری خود را کوتاه توضیح دهید؛ مثلاً ورود مشکوک یا پیام فیشینگ." },
      { title: "کدام حساب یا دستگاه؟", body: "بگویید کدام حساب یا دستگاه درگیر است؛ مثلاً حساب ایمیل یا تلفن همراه." },
      { title: "این دستگاه امن است؟", body: "اگر ممکن است دستگاه پایش شده، گم‌شده یا توقیف‌شده باشد، به ما بگویید." },
    ],
    warning: "گذرواژه، کد تأیید یا فایل مشکوک نفرستید.", pgpTitle: "ایمیل حساس می‌فرستید؟",
    pgpBody: "اثر انگشت کلید عمومی را از یک کانال مورداعتماد دیگر تطبیق دهید.", fingerprintAction: "نمایش اثر انگشت",
    next: ["خطر را بررسی می‌کنیم", "دربارهٔ گام امن‌تر توافق می‌کنیم", "اطلاعات را فقط با رضایت شما جمع‌آوری می‌کنیم"],
  };
  return {
    title: t.heroTitle, body: t.heroBody, recommended: t.recommended, firstTitle: t.urgentTitle,
    prompts: t.safety[0].items.map((body) => ({ title: "", body })),
    warning: t.safety[1].items[0], pgpTitle: t.pgpTitle, pgpBody: t.pgpBody, fingerprintAction: t.fingerprint, next: t.safety[2].items,
  };
}
